import React from 'react';

import { Card, CardBody, Image, Text } from '@change/ds-core-ui';
import { CheckmarkVerifiedIcon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core/react/i18n';

import news1 from 'src/assets/sap/news-1.png';
import news2 from 'src/assets/sap/news-2.png';
import news3 from 'src/assets/sap/news-3.png';

export const StaticSupportCards: React.FC = () => {
	const { translate, localizeNumber } = useI18n();
	const newsIconImages: readonly string[] = [news1, news2, news3];

	return (
		<div className="grid grid-cols-2 gap-4">
			<Card
				orientation="vertical"
				className="elevation-elevated bg-fill-inverse-strong col-span-1 w-full [--card-gap:0] [--card-padding:0]"
			>
				<CardBody className="flex flex-col px-6! py-4">
					<div className="flex items-center gap-2">
						<Text as="p" size="x-large" fontWeight="bold">
							3
						</Text>
						<div className="flex gap-1">
							{newsIconImages.map((src, index) => (
								<div
									key={index}
									className="border-stroke-weaker flex h-6 w-6 items-center overflow-hidden rounded-full border"
								>
									<Image
										src={src}
										alt={translate('corgi.start_a_petition.chat_app_entry.get_voice_heard_section.news_icon_alt')}
										className="aspect-auto"
									/>
								</div>
							))}
						</div>
					</div>

					<Text as="p" size="x-small">
						{translate('corgi.start_a_petition.chat_app_entry.get_voice_heard_section.media')}
					</Text>
				</CardBody>
			</Card>

			<Card
				orientation="vertical"
				className="elevation-elevated bg-fill-inverse-strong col-span-1 w-full [--card-gap:0] [--card-padding:0]"
			>
				<CardBody className="flex flex-col px-6! py-4">
					<Text as="p" size="x-large" fontWeight="bold">
						14
					</Text>
					<Text as="p" size="x-small">
						{translate('corgi.start_a_petition.chat_app_entry.get_voice_heard_section.comments')}
					</Text>
				</CardBody>
			</Card>

			<Card
				orientation="vertical"
				className="elevation-elevated bg-fill-inverse-strong col-span-2 w-full text-center [--card-gap:0] [--card-padding:0]"
			>
				<CardBody className="flex flex-col items-center justify-center gap-2 pt-5 pb-6">
					<div className="flex gap-1">
						<Text variant="heading" size="x-large" as="p">
							{localizeNumber(10097)}
						</Text>
						<CheckmarkVerifiedIcon
							className="text-icon-accent-primary"
							aria-label={translate(
								'corgi.start_a_petition.chat_app_entry.get_voice_heard_section.verified_signatures_alt',
							)}
						/>
					</div>

					<Text as="p" size="small">
						{translate('corgi.start_a_petition.chat_app_entry.get_voice_heard_section.verified_signatures')}
					</Text>
				</CardBody>
			</Card>
		</div>
	);
};
